export const normalizeAccount = value => String(value || '').trim().toLowerCase();
export function sameAccountSession(a, b) {
  return !!a?.token && a.token === b?.token && !!normalizeAccount(a.email) && normalizeAccount(a.email) === normalizeAccount(b?.email);
}
export const deletionError = error => ({
  ownership_transfer_required: 'Transfer ownership of your organizations before deleting your account.',
  account_deletion_unavailable: 'Account deletion is unavailable right now. Contact support to request it.',
  confirmation_required: 'Type DELETE to confirm.',
  foreign_identity_not_allowed: 'Could not verify your account. Nothing was deleted.',
  server_error: 'The server could not delete your account. Please try again.',
}[error] || error || 'The server did not confirm deletion. Your local data was kept.');

export function deletionPreflight(session, { email, pin, confirmation }) {
  if (!session?.token || !normalizeAccount(session.email)) return 'Sign in to delete your account.';
  if (normalizeAccount(email) !== normalizeAccount(session.email)) return 'Re-enter the email of the account you are signed into.';
  if (typeof pin !== 'string' || pin.trim().length < 4) return 'Enter your current PIN.';
  if (String(confirmation).trim().toUpperCase() !== 'DELETE') return 'Type DELETE to confirm.';
  return null;
}

export async function deleteCurrentAccount(input, { readSession, request }) {
  const session = readSession();
  const error = deletionPreflight(session, input);
  if (error) return { ok: false, error };
  try {
    const response = await request({ action: 'delete_account', confirm: 'DELETE', accountPin: input.pin }, session);
    if (!sameAccountSession(session, readSession())) return { ok: false, error: 'Your session changed. Your current account was not changed.' };
    if (!response.ok || response.body?.success !== true || normalizeAccount(response.body?.deleted) !== normalizeAccount(session.email)) {
      return { ok: false, error: deletionError(response.body?.error) };
    }
    return { ok: true, session };
  } catch { return { ok: false, error: 'Could not reach the server. Your local data was kept.' }; }
}

export const REPORT_REASONS = [
  ['harassment', 'Harassment or bullying'], ['inappropriate', 'Inappropriate content'],
  ['spam', 'Spam or scam'], ['impersonation', 'Impersonation'], ['other', 'Something else'],
];
export async function reportUser({ target, reason, detail = '', context = 'profile' }, { readSession, request }) {
  const session = readSession();
  if (!session?.token) return { ok: false, error: 'Sign in to send a report.' };
  if (!normalizeAccount(target) || normalizeAccount(target) === normalizeAccount(session.email)) return { ok: false, error: 'Choose another person to report.' };
  if (!REPORT_REASONS.some(([key]) => key === reason)) return { ok: false, error: 'Choose a report reason.' };
  try {
    const response = await request({ target: normalizeAccount(target), reason, detail: detail.trim().slice(0, 1000), context: context.slice(0, 40) }, session);
    if (!sameAccountSession(session, readSession())) return { ok: false, error: 'Your session changed. Please try again.' };
    return response.ok && response.body?.success === true ? { ok: true } : { ok: false, error: response.body?.error || 'Could not send the report. Please try again.' };
  } catch { return { ok: false, error: 'Could not send the report. Check your connection.' }; }
}
